import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseView, BaseText } from '../base'
import { CardItem } from '../CardItem'
import { AppIcons } from '../AppIcons'

import { formatAddress } from '@/utils'
import { useTheme } from '@/hooks/useTheme'

interface SelectedAddressDisplayProps {
  id?: string
  name: string
  address: string
  onPress?: () => void
  isLoading?: boolean
}

export const SelectedAddressDisplay: React.FC<SelectedAddressDisplayProps> = ({
  name,
  address,
  onPress,
  isLoading = false,
}) => {
  const { t } = useTranslation()
  const theme = useTheme()

  if (isLoading) {
    return (
      <div className="animate-pulse">
        <div className="bg-gray-700 rounded-xl p-4 h-20"></div>
      </div>
    )
  }

  return (
    <CardItem.Root
      onPress={onPress}
      style={{
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
      }}
      className="hover:bg-gray-700 transition-colors"
    >
      <BaseView gap={8} flex={1}>
        <BaseText fontSize={16} fontFamily="semibold" color="label.default">
          {name || t('translation:unnamed')}
        </BaseText>
        <BaseText
          fontSize={14}
          fontFamily="regular"
          color="label.description"
          style={{ fontFamily: 'monospace' }}
        >
          {formatAddress(address)}
        </BaseText>
      </BaseView>

      <AppIcons
        name="chevronRight"
        size={24}
        color={theme.colors.icon?.iconCard || '#666'}
      />
    </CardItem.Root>
  )
}
